// API 调用 actions

export const actions = {
  prepare ({ state, dispatch, rootState }, params) {
    return rootState.axios
      .post('/jyo/v1frontend/jyorder-create/prepare', params)
      .then(async (res) => {
        res.data.model.parcels = await dispatch(
          'jyo/jyorder/formatOrderParcelList',
          res.data.model.parcels,
          { root: true }
        )
        return res
      })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post(
      '/jyo/v1frontend/jyorder-create/create',
      params
    )
  },
  createSea ({ state, commit, rootState }, params) {
    return rootState.axios.post(
      '/jyo/v1frontend/jyorder-create/create-sea',
      params
    )
  },
  createSeaItemmold6 ({ state, commit, rootState }, params) {
    return rootState.axios.post(
      '/jyo/v1frontend/jyorder-create/batch-create-sea-itemmold6',
      params
    )
  },
  createMessy ({ state, commit, rootState }, params) {
    return rootState.axios.post(
      '/jyo/v1frontend/jyorder-create/create-messy',
      params
    )
  },
  changeCneeAddr ({ state, commit, rootState }, params) {
    return rootState.axios.post(
      '/jyo/v1frontend/jyorder-create/change-cnee-addr',
      params
    )
  },
  checkAddress ({ state, commit, rootState }, params) {
    return rootState.axios.post(
      '/jyo/v1frontend/jyorder-create/check-address',
      params
    )
  },
  calcDeclCargoes ({ rootState }, params) {
    return rootState.axios.post(
      '/jyo/v1frontend/jyorder-create/calc-decl-cargoes',
      params
    )
  },
}
